interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export function Spinner({ size = 'md', label = 'Cargando' }: SpinnerProps) {
  const sz = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-12 w-12' : 'h-6 w-6';
  return (
    <div role="status" aria-live="polite" className="inline-flex items-center gap-2 relative">
      <div className="relative">
        <div className="absolute inset-0 bg-cubus-lime/25 blur-xl rounded-full" aria-hidden="true" />
        <div
          className={`relative animate-spin rounded-full border-2 border-white/10 border-t-cubus-lime ${sz}`}
        />
      </div>
      <span className="sr-only">{label}</span>
    </div>
  );
}
